import type { LucideIcon } from 'lucide-react';
import { cn } from '@nepal-ecom/ui';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  tone?: 'slate' | 'primary' | 'amber' | 'emerald';
  className?: string;
}

const TONES = {
  slate: 'bg-slate-100 text-slate-500',
  primary: 'bg-primary-50 text-primary-600',
  amber: 'bg-amber-50 text-amber-600',
  emerald: 'bg-emerald-50 text-emerald-600',
};

export function EmptyState({ icon: Icon, title, description, action, tone = 'slate', className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center py-16 px-6', className)}>
      <div className={cn('h-14 w-14 rounded-2xl flex items-center justify-center mb-4 ring-1 ring-inset ring-slate-200', TONES[tone])}>
        <Icon className="h-6 w-6" />
      </div>
      <h3 className="text-base font-semibold text-slate-900">{title}</h3>
      {description && <p className="text-sm text-slate-500 mt-1 max-w-md">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
